<div class="forget__first">
  <div class="auth__header flex flex-col gap-4 text-center">
    <h2 translate>Forget Password?</h2>
    <p translate>No Worries We will Send Some Instructions</p>
  </div>

  <form class="mt-6 flex flex-col gap-4" [formGroup]="form" (submit)="submit()">
    <input-text
      [options]="{ label: 'Email', control: form.controls.email, isShowErrors }"
    ></input-text>
    <div class="w-full flex justify-center">
      <input-recaptcha
        [options]="{
          control: form.controls.recaptcha,
          isShowErrors: isShowErrors,
        }"
      ></input-recaptcha>
    </div>

    <button type="submit" class="primary__btn w-full mt-12" translate>
      Next
    </button>
  </form>
</div>
